export default ({ request }) => ({
    ecomAmzSkuInvFtyLocationListApi(data = {}) {
      return request({
        url: '/ecom/ecomAmzSkuInvFtyLocation/list',
        method: 'POST',
        data
      })
    },
    ecomAmzSkuInvFtyLocationListTotalApi(data = {}) {
      return request({
        url: '/ecom/ecomAmzSkuInvFtyLocation/listTotal',
        method: 'POST',
        data
      })
    },
    ecomAmzStorageLocationsUpdateApi(data = {}) {
      return request({
        url: '/ecom/ecomAmzSkuInvFtyLocation/storage/locations/update',
        method: 'POST',
        data
      })
    }
  })
  